import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mt-8" }
const _hoisted_2 = { class: "w-full table-auto" }
const _hoisted_3 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  scope: "col",
  class: "flex items-center justify-between px-2 py-2"
}
const _hoisted_6 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_7 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_8 = { class: "px-2 py-3 capitalize" }
const _hoisted_9 = { class: "px-2 py-2 capitalize" }
const _hoisted_10 = { class: "px-2 py-2" }

import { ref } from "vue";

import TitleHeader from "@/components/TitleHeader.vue";

import api from "@/api/api";
import { PaginationMeta } from "@/types";

import SortableTableHeader from "@/components/tables/SortableTableHeader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserGroups',
  async setup(__props) {

let __temp: any, __restore: any

const roles = ref();
const meta = ref({} as PaginationMeta);

try {
  const response = (
  ([__temp,__restore] = _withAsyncContext(() => api.users.listUsersByRole())),
  __temp = await __temp,
  __restore(),
  __temp
);
  roles.value = response.data;
  meta.value = response.meta;
} catch (error) {
  window.location.href = "/error";
}

const sortedRoles = ref(roles.value);

async function sortTable(_: string, direction: string) {
  // Sort the object of objects by the display_name property
  sortedRoles.value = roles.value.sort((a: any, b: any) => {
    if (direction === "asc") {
      return a.display_name.localeCompare(b.display_name);
    } else {
      return b.display_name.localeCompare(a.display_name);
    }
  });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('user-groups')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("thead", _hoisted_3, [
            _createElementVNode("tr", _hoisted_4, [
              _createElementVNode("th", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.$t("group")) + " ", 1),
                _createVNode(SortableTableHeader, {
                  column: "display_name",
                  onSort: sortTable
                })
              ]),
              _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("users")), 1),
              _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("view")), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedRoles.value, (role) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "border-b border-gray-400",
                key: role
              }, [
                _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$t(role.name)), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(role.users.length), 1),
                _createElementVNode("td", _hoisted_10, [
                  _createVNode(_component_router_link, {
                    to: { name: 'User_Group', params: { role: role.name } },
                    class: "underline text-blue"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 64))
}
}

})